<div class="custom-modal-container {{errorName?.toLowerCase()}}">
  <div class="custom-modal-container-content primary">
    <div (click)="close()" class="close-button">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
      </svg>
    </div>
    <i class="modal-icon error">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="errorIcon"></use>
      </svg>
    </i>
    <div class="content-container">
      <h2 class="modal-title">{{ action | translate }}</h2>
      <p class="modal-paragraph" [innerHTML]="stringInfo | translate: { param1: userName }"></p>
      <div class="button-container">
        <a class="primary-button" (click)="close()">{{ 'Close' | translate }}</a>
      </div>
    </div>
  </div>
</div>
